import type { PlainTaskExecution } from "@/queries/automations-queries";
import { TaskExecutionPhase } from "gitpod-next-api/gitpod/v1/environment_automation_pb";
import { type FC, useMemo } from "react";
import { type LabelPhase, PhaseLabel } from "@/components/environments/PhaseLabel";

export const EnvironmentTaskRunStatus: FC<{ taskExecution: PlainTaskExecution }> = ({ taskExecution }) => {
    const phase = useMemo((): LabelPhase => {
        const finished =
            taskExecution.status?.phase === TaskExecutionPhase.SUCCEEDED ||
            taskExecution.status?.phase === TaskExecutionPhase.FAILED ||
            taskExecution.status?.phase === TaskExecutionPhase.STOPPED;
        if (taskExecution.spec?.desiredPhase === TaskExecutionPhase.STOPPED && !finished) {
            // Optimistically update state to STOPPING
            return "stopping";
        }

        switch (taskExecution.status?.phase) {
            case TaskExecutionPhase.SUCCEEDED:
                return "succeeded";
            case TaskExecutionPhase.FAILED:
                return "failed";
            case TaskExecutionPhase.RUNNING:
                return "running";
            case TaskExecutionPhase.PENDING:
                return "starting";
            case TaskExecutionPhase.STOPPED:
                return "stopped";
            default:
                return "unspecified";
        }
    }, [taskExecution.status?.phase, taskExecution.spec?.desiredPhase]);

    return <PhaseLabel phase={phase} />;
};
